import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { useState } from 'react';
import ExpandMoreIcon from './ExpandMoreIcon';

export default function CustomAccordion({ accordians = []}) {
  const [expanded, setExpanded] = useState('');

  const handleChange =
    (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };

  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    '&:before': {
      display: 'none',
    },
  }));

  const elements = accordians.map((item, i) => {
    return (
      <Accordion key={'panel' + i} expanded={expanded === 'panel' + i} onChange={handleChange('panel' + i)}>
        <AccordionSummary expandIcon={item?.expand ? <ExpandMoreIcon show={item.details !== undefined}/> : undefined} aria-controls={"panel" + i + "bh-content"} id={"panel" + i + "bh-header"}
        >{item.summary}</AccordionSummary>
        <AccordionDetails>{item.details}</AccordionDetails>
      </Accordion>
    );
  });

  return (
    <div>
      {elements}
    </div>
  );
}